module.exports = __webpack_public_path__ + "static/img/brees-2013-top-image.f0864fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-top-image.jpg
// module id = fI4E
// module chunks = 1